import { formatLatLng, Point } from "@cartographerio/geometry";
import {
  formatTimestampIso8601,
  ProjectId,
  SurveyId,
  Timestamp,
  WorkspaceRef,
} from "@cartographerio/types";
import { UrlQuery } from "../../../url";

export interface FeatureSearchParamsV1 {
  workspace?: WorkspaceRef | null;
  sw?: Point | null;
  ne?: Point | null;
  from?: Timestamp | null;
  to?: Timestamp | null;
  survey?: SurveyId | null;
  simplify?: boolean | null;
}

export function formatFeatureSearchParamsV1(
  params: FeatureSearchParamsV1
): UrlQuery {
  const { workspace, sw, ne, from, to, survey, simplify } = params;

  return {
    workspace,
    sw: sw == null ? undefined : formatLatLng(sw),
    ne: ne == null ? undefined : formatLatLng(ne),
    from: from == null ? undefined : formatTimestampIso8601(from),
    to: to == null ? undefined : formatTimestampIso8601(to),
    survey,
    format: "geojson",
    simplify,
  };
}

export interface FeatureSearchParamsV2 {
  project: ProjectId;
  sw?: Point | null;
  ne?: Point | null;
  from?: Timestamp | null;
  to?: Timestamp | null;
  survey?: SurveyId | null;
  simplify?: boolean | null;
}

export function formatFeatureSearchParamsV2(
  params: Partial<FeatureSearchParamsV2>
): UrlQuery {
  const { project, sw, ne, from, to, survey, simplify } = params;

  return {
    project,
    sw: sw == null ? undefined : formatLatLng(sw),
    ne: ne == null ? undefined : formatLatLng(ne),
    from: from == null ? undefined : formatTimestampIso8601(from),
    to: to == null ? undefined : formatTimestampIso8601(to),
    survey,
    format: "geojson",
    simplify,
  };
}
